import _ from 'lodash';
import {apiFetch, apiSearch} from '../utility';

const apiBase = 'splitBillPage';
export const split = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.splitMultiPage`,
			listNameToUpdate : 'splitBillPageIds',
			params,
			dispatch,
			callback,
		});
	};
};

export const search = (p = {}) => {
	const { callback = _.noop } = p;
	return dispatch => {
		apiSearch({
			base : apiBase,
			params : {},
			dispatch,
			callback,
		});
	};
};
